var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('client-informations'),_vm._v(" "),_c('changing-password'),_vm._v(" "),_c('newsletter-subscription'),_vm._v(" "),_c('remove-profile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }